import { mapContentfulImageAsset } from '@utils/contentful/contentfulImage'
import { GenericContentBlock } from 'types/contentful/genericContentBlock'

export function toUploadContent(
  sectionContent: GenericContentBlock,
  fallbackCopy: { title: string; subtitle: string }
) {
  return {
    title: sectionContent?.h1 || fallbackCopy?.title,
    subtitle: sectionContent?.h2 || fallbackCopy?.subtitle,
    footer: sectionContent?.h3,
    icon: mapContentfulImageAsset(sectionContent?.primaryImages?.[0]),
  }
}
